/**
 * SharePoint 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <SharePointIcon className="w-8 h-8" />
 * <SharePointIcon className="w-12 h-12" />
 * ```
 */
export function SharePointIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="SharePoint icon"
      role="img"
    >
      <title>SharePoint</title>
      <g id="Sharepoint">
        <g id="Vector">
          <path
            d="M16.3295 17.9385C20.6479 17.9385 24.1487 14.4825 24.1487 10.2192C24.1487 5.95602 20.6479 2.5 16.3295 2.5C12.011 2.5 8.5102 5.95602 8.5102 10.2192C8.5102 14.4825 12.011 17.9385 16.3295 17.9385Z"
            fill="#036C70"
          />
          <path
            d="M22.8397 24.3567C26.7942 24.3567 30 21.1919 30 17.288C30 13.384 26.7942 10.2192 22.8397 10.2192C18.8851 10.2192 15.6793 13.384 15.6793 17.288C15.6793 21.1919 18.8851 24.3567 22.8397 24.3567Z"
            fill="#1A9BA1"
          />
          <path
            d="M17.3047 29.5C20.3616 29.5 22.8397 27.0536 22.8397 24.0358C22.8397 21.018 20.3616 18.5716 17.3047 18.5716C14.2478 18.5716 11.7697 21.018 11.7697 24.0358C11.7697 27.0536 14.2478 29.5 17.3047 29.5Z"
            fill="#37C6D0"
          />
          <path
            d="M3.19485 8.92692H15.1258C15.7848 8.92692 16.3207 9.45599 16.3207 10.1065V21.8848C16.3207 22.5353 15.7848 23.0644 15.1258 23.0644H3.19485C2.53593 23.0644 2 22.5353 2 21.8848V10.1065C2 9.45599 2.53593 8.92692 3.19485 8.92692Z"
            fill="#008789"
          />
          <path
            d="M7.33291 15.8742C7.05177 15.6921 6.82334 15.4492 6.64763 15.163C6.4807 14.8681 6.40163 14.5299 6.41042 14.1916C6.39285 13.7319 6.55099 13.2809 6.8497 12.9253C7.16599 12.5697 7.57013 12.3095 8.02698 12.1707C8.54534 12.0059 9.09005 11.9192 9.63477 11.9279C10.3552 11.9019 11.0668 11.9973 11.7521 12.2228V13.7059C11.4534 13.5324 11.1283 13.4023 10.7945 13.3243C10.4255 13.2376 10.0565 13.1942 9.67869 13.1942C9.28334 13.1768 8.88798 13.2636 8.52777 13.437C8.25541 13.5585 8.07091 13.8187 8.07091 14.1222C8.07091 14.3044 8.1412 14.4778 8.2642 14.6079C8.41356 14.7641 8.58927 14.8855 8.78255 14.9722C9.0022 15.0763 9.32727 15.2237 9.75777 15.3972C9.80169 15.4146 9.85441 15.4319 9.89834 15.4492C10.3288 15.614 10.7418 15.8135 11.1283 16.0477C11.427 16.2298 11.673 16.4727 11.8575 16.7676C12.042 17.1058 12.1299 17.4788 12.1211 17.8604C12.1387 18.3288 11.9981 18.7971 11.7082 19.1788C11.4183 19.5257 11.0317 19.7772 10.6012 19.916C10.0916 20.0721 9.55569 20.1502 9.01977 20.1415C8.53655 20.1415 8.06213 20.1068 7.5877 20.0287C7.19234 19.968 6.79699 19.8553 6.42799 19.6905V18.1293C6.77942 18.3808 7.18356 18.563 7.60527 18.6844C8.02698 18.8145 8.45748 18.8839 8.89677 18.8925C9.30091 18.9186 9.70505 18.8318 10.074 18.6497C10.3288 18.5109 10.4782 18.2421 10.4782 17.9558C10.4782 17.7563 10.3991 17.5655 10.2585 17.4268C10.0828 17.2533 9.87198 17.1145 9.65234 17.0104C9.38877 16.8803 9.01098 16.7155 8.50141 16.4987C8.09236 16.3247 7.80111 16.1776 7.33291 15.8742Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
}
